import { fetchWrapperPortal } from "./fetch";

export const overlayTemplateAPI = {
  // Get all overlay templates with optional filter
  getAll: async (filter = 'active') => {
    const url = filter ? `overlay_templates?state=${filter}` : 'overlay_templates';
    return await fetchWrapperPortal({
      url,
      method: 'GET',
      addBearer: true,
    });
  },

  // Create new overlay template
  create: async (templateData) => {
    return await fetchWrapperPortal({
      url: 'overlay_templates',
      method: 'POST',
      addBearer: true,
      body: JSON.stringify(templateData),
    });
  },

  // Update existing overlay template
  update: async (templateId, templateData) => {
    return await fetchWrapperPortal({
      url: `overlay_templates/${templateId}`,
      method: 'PUT',
      addBearer: true,
      body: JSON.stringify(templateData),
    });
  },

  // Toggle template state (active/inactive)
  toggleState: async (templateId, currentState) => {
    const newState = currentState === 'active' ? 'inactive' : 'active';
    return await overlayTemplateAPI.update(templateId, { state: newState });
  }
}; 